import { commonRequest } from "@devowl-wp/utils";
import { RootStore } from "../store";
import deepMerge from "deepmerge";
async function realCommerceRequest(passOptions) {
  const {
    lang
  } = document.documentElement;
  try {
    return await commonRequest({
      ...passOptions,
      options: {
        restNamespace: "1.0.0",
        restNonce: "",
        restQuery: {},
        restRoot: RootStore.get.optionStore.others.realCommerceRestRoot
      },
      settings: deepMerge.all([passOptions.settings || {}, {
        headers: {
          ...(lang ? {
            "Accept-Language": lang
          } : {})
        }
      }])
    });
  } catch (e) {
    // TODO: we need to replace this with a real frontend monitoring
    console.error("realCommerceRequest", JSON.stringify(passOptions, null, 4), JSON.stringify(e, null, 4));
    throw e;
  }
}
export { realCommerceRequest };